import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import ShimmerImage, { ShimmerThumbnailImage } from "../../default/popup/shimmerImage/shimmerImage";
import { InitialAvatar } from "../../default/utils/defaultAvatar";

const BusinessProfile = ({ data }) => {
    const businessData = data ? data : '';
    return (
        <div className="sng-bus-profile-area">
            <div className="sng-cover-photo">
                <ShimmerThumbnailImage
                    src={businessData.feature_photo_url}
                    alt={businessData.name}
                    height={220}
                />
            </div>
            <div className="sng-profile-area">
                {businessData.logo_url ? (
                    <ShimmerImage
                        src={businessData.logo_url}
                        alt={businessData.name}
                        width={180}
                    />
                ) : (
                    <InitialAvatar
                        title={`${businessData.name}`}
                        size={65}
                    />
                )}
                <div className="sng-profile-details">
                    <strong>{businessData.name}</strong>
                    <p>{data?.tagLine}</p>
                </div>
                <Link to={`/business/update/${businessData.id}`}><i className="ri-edit-2-line"></i> Edit</Link>
            </div>
        </div>
    );
}

export default BusinessProfile;